import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { fields } from "../../common/lib/redux-fields";
import { ValidationError } from "../../common/lib/validation";
import { hashFromObj } from "../../common/lib/utils/hash";
import { Link } from "react-router";

import {
  Container,
  Row,
  Col,
  Form as BootstrapForm,
  FormGroup,
  Label,
  FormFeedback,
  Button
} from "reactstrap";

import { get } from "../../common/application/actions";

import Input from "../../browser/components/Form/Input";

import moment from "moment";

moment.locale("pl");

const formFields = [
  "offerUID",
  "firstName",
  "lastName",
  "email",
  "phoneNumber",
  "isSent"
];

const formPath = "applicationForm";

class Form extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { params, get, fields } = this.props;

    fields.$reset();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  render() {
    const { apiHost, fields, obj } = this.props;

    const dirty = Object.keys(fields.$valuesChanged()).length > 0;

    return (
      <BootstrapForm
        onSubmit={e => {
          e.preventDefault();
        }}
        noValidate
      >
        <Container>
          <Row>
            <Col xs="6">
              <Input
                field="offerUID"
                title="Oferta"
                type="text"
                staticField
                value={
                  fields.offerUID.value ? (
                    <Link to={"/offers/edit/" + fields.offerUID.value}>
                      Przejdź do oferty
                    </Link>
                  ) : (
                    "Brak oferty"
                  )
                }
              />
              <Input
                field="firstName"
                title="Imię"
                type="text"
                staticField
                {...fields.firstName}
              />
              <Input
                field="lastName"
                title="Nazwisko"
                type="text"
                staticField
                {...fields.lastName}
              />
              <Input
                field="email"
                title="Email"
                type="text"
                staticField
                {...fields.email}
              />
              <Input
                field="phoneNumber"
                title="Telefon"
                type="text"
                staticField
                {...fields.phoneNumber}
              />
              <Input
                field="isSent"
                title="Wysłana"
                type="checkbox"
                checked={fields.isSent.value}
                loading={true}
                {...fields.isSent}
              />
            </Col>
            <Col xs="6" />
          </Row>
        </Container>
      </BootstrapForm>
    );
  }
}

Form.contextTypes = {
  router: React.PropTypes.object.isRequired
};

Form = fields(Form, {
  path: formPath,
  fields: formFields,
  getInitialState: ({ obj }) => {
    return {
      offerUID: obj.get("offerUID"),
      firstName: obj.get("firstName"),
      lastName: obj.get("lastName"),
      email: obj.get("email"),
      phoneNumber: obj.get("phoneNumber"),
      isSent: obj.get("isSent") * 1
    };
  }
});

Form = connect(
  state => ({
    apiHost: state.config.apiHost,
    fields: state.fields,
    appPath: state.config.appPath
  }),
  { get }
)(Form);

export { Form, formFields };



// WEBPACK FOOTER //
// ./src/browser/application/Form.js